module.exports = require("@mui/icons-material/FirstPage");